import axios from 'axios';
import resultsTemplate from './inputSearch.template.hbs';

/**
 * Input search
 * Javascript functionality for input search with live search results.
 * @version 3.0.0
 * @exports InputSearch
 */
export default class InputSearch {
    /**
     * Constructor
     * @param {Object} el - The form element as a DOM node.
     * @public
     */
    constructor(el) {

        /** The form DOM node for the search */
        this.formNode = el;

        /** The search input field */
        this.formInput = this.formNode.querySelector('input');

        /** Loader within the results container */
        this.loader = this.formNode.querySelector('.loader');

        // Target id of results container
        this.resultsTargetId = this.formNode
            .querySelector('.search-form-wrapper')
            .getAttribute('aria-controls');

        /** Container of search results */
        this.resultsContainer = document.getElementById(this.resultsTargetId);

        // If request is in progress
        this.requestInProgress = false;

        // If visible
        this.visible = false;

        // Debounce timer
        this.timer = null;

        this.isUnloading = false;

        if (this.formNode) {
            this._init();
        }
    }

    /**
     * The initialization function for this module.
     * @private
     */
    _init() {
        window.addEventListener('beforeunload', () => {
            this.isUnloading = true;
        });

        this.formInput.addEventListener('input', e => {
            clearTimeout(this.timer);
            if (e.target.value.length > 2) {
                this.visible || this._showResult();
                this.timer = setTimeout(() => this._triggerAutocomplete(e.target.value), 800);
            } else {
                !this.visible || this._hideResult(true);
            }
        });

        this.formInput.addEventListener('focus', e => {
            if (!this.visible && e.target.value.length > 2) {
                this._showResult();
            }
        });

        window.addEventListener('click', e => {
            if (!this.formNode.contains(e.target)) {
                this._hideResult(false);
            }
        });
    }

    /**
     * Triggers autocomplete search
     * @param {String} value - The searched value
     */
    _triggerAutocomplete(value) {
        if (this.requestInProgress) {
            return;
        }
        if (this.isUnloading) {
            this.isUnloading = false;
            return;
        }

        this.requestInProgress = true;

        this._clearResult();
        this.loader.classList.remove('is-hidden');

        const method = this.formNode.getAttribute('method') || 'GET';
        const textParamName = this.formInput.getAttribute('name') || 'q';
        //const lang = document.documentElement.lang;
        //let lang = this.formNode.querySelector('#lang');

        let url = this.formNode.getAttribute('data-ajaxurl');
        url = `${url}?${textParamName}=${value}`;
        //const url = `${url}?${name}=${value}&${(lang && lang.name) || 'lang'}=${(lang && lang.value) || 'sv'}`;

        axios({ method, url })
            .then(response => {
                if (response.data && response.data.items && response.data.items.length) {
                    this._renderResults(response.data);
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    const error = document.documentElement.lang === 'sv' ?
                        'S&ouml;funktionen fungerar inte just nu, v&auml;nligen f&ouml;rs&ouml;k senare' :
                        'The search function is not working right now, please try again later';
                    this._renderResults({ error });
                }
                console.log(error);
            })
            .then(() => {
                this.requestInProgress = false;
                this.loader.classList.add('is-hidden');
            });
    }

    /**
     * 
     * */
    _showResult() {
        this.resultsContainer.classList.remove('is-hidden');
        this.resultsContainer.setAttribute('aria-hidden', false);
        this.formInput.setAttribute('aria-expanded', true);
        this.visible = true;
    }

    /**
     * 
     * */
    _hideResult(clearResult) {
        this.resultsContainer.classList.add('is-hidden');
        this.resultsContainer.setAttribute('aria-hidden', true);
        this.formInput.setAttribute('aria-expanded', false);
        this.visible = false;

        if (clearResult) {
            this._clearResult();
        }
    }

    _clearResult() {
        const alist = this.resultsContainer.querySelector('.article-list');
        alist && alist.remove();
    }

    /**
     * Renders results to
     * @param {Object} results - The results from backend
     */
    _renderResults(results) {
        const resultsHtml = resultsTemplate(results);
        this.resultsContainer.insertAdjacentHTML('BeforeEnd', resultsHtml);
    }
}
